let isCheck = true
export default {
    debounce(fn, delay) {
        let timer = null;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        }
    },
    throttle(fn, delay) {
        if (isCheck) {
            isCheck = false
            let timer = setTimeout(() => {
                isCheck = true
                clearTimeout(timer)
            }, delay)
            if (fn) fn()
        }
    },
    dateFormat(fmt = 'YYYY-MM-DD',dateTime){
        let date = new Date()
        dateTime ? date = new Date(dateTime) : ''
        const option = {
            Y: date.getFullYear(),        // 年
            M: date.getMonth()+1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth()+1,          // 月
            D: date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),                     // 日
            h: date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),                  // 时
            m: date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),            // 分
            s: date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()             // 秒
        };
        if(fmt === 'YYYY-MM-DD'){
            return `${option.Y}-${option.M}-${option.D}`
        }else{
            return `${option.Y}-${option.M}-${option.D} ${option.h}:${option.m}:${option.s}`
        }
    },
    IsPhone() {
        //获取浏览器navigator对象的userAgent属性（浏览器用于HTTP请求的用户代理头的值）
        var info = navigator.userAgent;
        // navigator.userAgent.indexOf('mobile')
        //通过正则表达式的test方法判断是否包含“Mobile”字符串
        var isPhone = /mobile/i.test(info);
        //如果包含“Mobile”（是手机设备）则返回true
        return isPhone;
    }
}